import Component from '../inherited/Component'

export default class StickyBar extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._target = document.querySelector(this._options.target)
    this._offset = parseFloat(getComputedStyle(document.body).paddingTop)
  }

  mount () {
    window.addEventListener('scroll', e => {
      this._setActive()
    }, { passive: true })
    this._setActive()
  }

  _setActive () {
    let offsetBottom = this._target.getBoundingClientRect().bottom
    if ((offsetBottom - this._offset) <= 0) {
      this._elem.classList.remove('hide-i')
    } else {
      this._elem.classList.add('hide-i')
    }
  }
}